module.exports = __webpack_public_path__ + "img/management.a5118a8d.svg";